"use strict";

exports.__esModule = true;
exports.useClickOutside = useClickOutside;

var React = _interopRequireWildcard(require("react"));

var _useEventListener = require("./useEventListener");

var _useUpdatedRef = require("./useUpdatedRef");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useClickOutside(handler, nodes) {
  var elementRef = React.useRef();
  var handlerRef = (0, _useUpdatedRef.useUpdatedRef)(handler);
  var handleClick = React.useCallback(function (event) {
    var target = event.target;

    if (Array.isArray(nodes)) {
      var shouldTrigger = nodes.every(function (node) {
        return (node == null ? void 0 : node.current) && !node.current.contains(target);
      });
      shouldTrigger && (handlerRef.current == null ? void 0 : handlerRef.current(event));
    } else if (elementRef.current && !elementRef.current.contains(target)) {
      handlerRef.current == null ? void 0 : handlerRef.current(event);
    }
  }, [elementRef, handlerRef, nodes]);
  (0, _useEventListener.useEventListener)('click', handleClick);
  (0, _useEventListener.useEventListener)('touchend', handleClick);
  return elementRef;
}